import api from "PFCore/api";

export type SendWelcomeEmailResponse = {
  message: string;
};

export const sendWelcomeEmails = (
  profileIds: string[],
  forceSendEmail?: boolean
): Promise<SendWelcomeEmailResponse> =>
  api({
    method: "post",
    url: "admin/users/send_welcome_emails",
    data: {
      profileIds,
      ...(forceSendEmail ? { forceSendEmail } : {})
    },
    apiVersion: 1
  });
